import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Manufactury, UsersQueryResponse} from './_models'
const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/api/v3/ManufacturyV`
const GET_USERS_URL = `${API_URL}/api/v3/ManufacturyV/Get`

const getManufactury = (query: string): Promise<UsersQueryResponse> => {
    return axios
        .get(`${GET_USERS_URL}?${query}`)
        .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getManufacturyId = (id: ID): Promise<Manufactury | undefined> => {
    return axios
        .get(`${USER_URL}/${id}`)
        .then((response: AxiosResponse<Response<Manufactury>>) => response.data)
        .then((response: Response<Manufactury>) => response.data)
}

const createManufactury = (user: Manufactury) => {
    return axios
        .post(USER_URL, user)

}

const updateManufactury = (user: Manufactury) => {
    return axios
        .put(`${USER_URL}`, user)

}

const deleteManufactury = (userId: ID): Promise<void> => {
    return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const deleteSelectedManufacturys = (userIds: Array<ID>): Promise<void> => {
    const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
    return axios.all(requests).then(() => {})
}

export {getManufactury, deleteManufactury, deleteSelectedManufacturys, getManufacturyId, createManufactury, updateManufactury,API_URL}
